import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronUpIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1056_10080",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 24,
				y: 24,
				width: 24,
				height: 24,
				transform: "rotate(-180 24 24)",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1056_10080)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12 7.6L18 13.6L16.6 15L12 10.4L7.4 15L6 13.6L12 7.6Z",
				fill: "#4EA699"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgChevronUpIcon);
export { ForwardRef as ReactComponent };
